import MyImage from '@shared/components/myImage'
import React from 'react'
import styles from './style.module.scss'
import s1Image from '@assets/images/hil/s1.jpeg'
import location from '@assets/images/hil/location.svg'
import people from '@assets/images/hil/people.svg'
import CustomLink from '@shared/components/customLink'
import PropTypes from 'prop-types'
import Image from 'next/future/image'
import { S3_PREFIX } from '@shared-submodule/sm-constants'

function VenueMweb({ venues, isMobile = false }) {
  const venueCapacity = [
    { capacity: '20,111', imgUrl: 'media/attachments/1739179407056_Barboune.jpeg' },
    { capacity: '25,021', imgUrl: 'media/attachments/1739256225878_Stadium.jpeg' },
    { capacity: '30,711', imgUrl: 'media/attachments/1739179473915_Kotambi.jpeg' },
    { capacity: '34,238', imgUrl: 'media/attachments/1739179479069_Locknow.jpeg' }
  ]

  return (
    <div className={styles.venueContainer}>
      {(venues || [])?.map((venue, i) => {
        const capacity = venueCapacity[i % venueCapacity.length]?.capacity
        const imgUrl = `${S3_PREFIX}${venueCapacity[i % venueCapacity.length]?.imgUrl}`
        return (
          <div className="w-100 d-flex flex-column justify-content-between align-item-center gap-2" key={i}>
            <div className="w-100 d-flex justify-content-center">
              <Image
                alt="Stadium Image"
                unoptimized={true}
                src={imgUrl || s1Image}
                height={115}
                width={200}
                className={styles.stadiumImage}
                layout="raw"
              />
            </div>
            <div className="w-100">
              {!isMobile ? (
                <CustomLink href={`/${venue?.oSeo?.sSlug}`}>
                  <a>
                    <div className={`${styles.stadiumTitle}`}>{venue?.sName || ''}</div>
                  </a>
                </CustomLink>
              ) : (
                <div className={`${styles.stadiumTitle}`}>{venue?.sName || ''}</div>
              )}
              <div className="d-flex justify-content-center gap-2 mt-2">
                <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
                  <MyImage src={location} alt="Location" className={styles.loImg} />
                  <p className="mb-0">{venue?.sLocation || ''}</p>
                </div>
                <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
                  <MyImage src={people} alt="People" className={styles.loImg} />
                  <p className="mb-0">{capacity}</p>
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

VenueMweb.propTypes = {
  venues: PropTypes.array,
  isMobile: PropTypes.bool
}

export default VenueMweb
